"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var DetailDataSingleLabel_1 = __importDefault(require("../contract_form/DetailDataSingleLabel"));
var date_parser_1 = __importDefault(require("../../../common/src/utils/date/date_parser"));
var SalesForceButtonArea_1 = __importDefault(require("./SalesForceButtonArea"));
var DatePickerWrapper_1 = __importDefault(require("../datepicker/DatePickerWrapper"));
var value_checker_1 = __importDefault(require("../../../common/src/utils/validation/value_checker"));
var ReflectType_1 = require("../../../common/src/types/sales_force/ReflectType");
var MoveSalesForceButton_1 = __importDefault(require("./MoveSalesForceButton"));
var SimpleDialog_1 = __importDefault(require("../globals/SimpleDialog"));
var PriceBookSelect_1 = __importDefault(require("./PriceBookSelect"));
var ProductSelect_1 = __importDefault(require("./ProductSelect"));
var FreePeriod_1 = __importDefault(require("./FreePeriod"));
var apply_service_utils_1 = __importDefault(require("../../../common/src/constrains/contract_form/apply_service_utils"));
var object_utils_1 = __importDefault(require("../../../common/src/utils/sales_force/object_utils"));
var contract_finish_1 = require("../../utils/mail/template/contract_finish");
var price_book_utils_1 = __importDefault(require("../../../common/src/utils/sales_force/price_book_utils"));
var OpportunityKobetu = /** @class */ (function (_super) {
    __extends(OpportunityKobetu, _super);
    function OpportunityKobetu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.form = {};
        _this.showAlertDialog = false;
        _this.alertMessage = '';
        _this.showConfirmDialog = false;
        _this.confirmMessage = '';
        _this.salesForceInfo = {
            torihikisakiId: '',
            opportunityId: '',
            kobetuPrice: '',
            kobetuContractState: '',
            kobetuRequestStartDate: null,
            kobetuContractEdate: null,
            kobetuItPeriod: '',
            kobetuBunkatuFlg: '',
            kobetuItFlg: '',
            kobetuTokubetuFlg: '',
            kobetuTokubetuDetail: '',
            opportunityKobetuId: '',
            opportunityKobetuName: '',
            kobetuContractStartDate: null,
            kobetuPriceBook2Id: '',
            kobetuProductId: '',
            useKobetuFreePeriod: [],
            opportunityKobetuItemId: '',
            kobetuPriceBook2Name: '',
            kobetuPriceBook2Description: '',
            kobetuProductName: '',
            kobetuPriceDefault: '',
            kobetuFreePriceBook2Id: '',
            kobetuFreePriceBook2Name: '',
            kobetuFreeProductId: '',
            kobetuFreeProductName: '',
            kobetuFreePeriod: '',
            freeOpportunityKobetuId: '',
            freeOpportunityKobetuItemId: '',
            freeOpportunityKobetuName: '',
            freeKobetuContractStartDate: '',
            kobetuPriceBookMonth: '',
            kobetuPriceBookData: [],
            kobetuProductPlanName: '',
            kobetuCancelFlag: '',
        };
        _this.useKobetuFreePeriod = '';
        _this.kobetuPrice = '';
        return _this;
    }
    OpportunityKobetu.prototype.kobetuPriceChange = function (newPrice) {
        this.kobetuPrice = String(newPrice);
        this.salesForceInfo.kobetuPrice = this.kobetuPrice;
    };
    OpportunityKobetu.prototype.getPlanName = function () {
        return contract_finish_1.ContractCompleteMailTemplate.getKobetuPlanName(this.form, this.salesForceInfo);
    };
    OpportunityKobetu.prototype.isCancelFlgDisable = function () {
        return price_book_utils_1.default.isNotStandardPriceBook(this.salesForceInfo.kobetuFreePriceBook2Id);
    };
    OpportunityKobetu.prototype.freePriceBookChange = function (newBookInfo) {
        this.salesForceInfo.kobetuFreePriceBook2Name = newBookInfo['name'];
        if (newBookInfo['cancelFlg']) {
            this.salesForceInfo.kobetuCancelFlag = 'true';
        }
        else {
            this.salesForceInfo.kobetuCancelFlag = '';
        }
    };
    OpportunityKobetu.prototype.freeProductChange = function (newProductInfo) {
        this.salesForceInfo.kobetuFreeProductName = newProductInfo['name'];
    };
    OpportunityKobetu.prototype.reCorrect = function () {
        this.$emit('re-correct');
    };
    OpportunityKobetu.prototype.onUseKobetuFreePeriodChange = function (newVal) {
        if (newVal) {
            this.salesForceInfo.useKobetuFreePeriod = [0];
        }
        else {
            this.salesForceInfo.useKobetuFreePeriod = [];
        }
        this.periodChange();
    };
    OpportunityKobetu.prototype.periodChange = function () {
        var sdate = this.form.applyInfoKinoKunrenStartDate;
        // 無料期間有り
        if (this.salesForceInfo.useKobetuFreePeriod && this.salesForceInfo.useKobetuFreePeriod.length) {
            this.salesForceInfo.freeKobetuContractStartDate = sdate;
            this.salesForceInfo.kobetuContractStartDate = object_utils_1.default.getSdateNextContract(sdate, this.salesForceInfo.kobetuFreePeriod);
        }
        else {
            this.salesForceInfo.kobetuContractStartDate = sdate;
        }
        this.salesForceInfo.kobetuRequestStartDate = object_utils_1.default.getSdateNextContract(this.salesForceInfo.kobetuContractStartDate, '1');
        if (this.salesForceInfo.kobetuPriceBookMonth === '1') {
            this.salesForceInfo.kobetuContractEdate = '';
        }
        else {
            this.salesForceInfo.kobetuContractEdate = object_utils_1.default.getEdateFromSdate(this.salesForceInfo.kobetuContractStartDate, this.salesForceInfo.kobetuPriceBookMonth);
        }
    };
    OpportunityKobetu.prototype.refs = function () {
        return this.$refs;
    };
    OpportunityKobetu.prototype.getTranslation = function (key) {
        return this.$t(key);
    };
    OpportunityKobetu.prototype.parseDate = function (dateStr) {
        return date_parser_1.default.toJapaneseDateStr(dateStr);
    };
    OpportunityKobetu.prototype.mounted = function () {
        this.initDataChange();
        this.initSalesForceDataChange();
    };
    OpportunityKobetu.prototype.salesForceAutoComplete = function () {
        if (value_checker_1.default.isBlank(this.salesForceInfo.kobetuContractStartDate)) {
            this.salesForceInfo.kobetuContractStartDate = this.form['applyInfoKinoKunrenStartDate'];
        }
        if (value_checker_1.default.isBlank(this.salesForceInfo.opportunityKobetuName)) {
            this.salesForceInfo.opportunityKobetuName = this.form.officeInfoOfficeName + "_" + date_parser_1.default.toString(new Date());
        }
        if (value_checker_1.default.isBlank(this.salesForceInfo.freeOpportunityKobetuName)) {
            this.salesForceInfo.freeOpportunityKobetuName = this.form.officeInfoOfficeName + "_" + date_parser_1.default.toString(new Date()) + "_\u7121\u6599";
        }
        if (price_book_utils_1.default.hasFree(this.salesForceInfo.useKobetuFreePeriod)) {
            this.useKobetuFreePeriod = 'true';
        }
        if (value_checker_1.default.isPresent(this.salesForceInfo.opportunityId) && value_checker_1.default.isBlank(this.salesForceInfo.opportunityKobetuId)) {
            if (apply_service_utils_1.default.isUseKobetuOpportunity(this.form)) {
                this.salesForceInfo.opportunityKobetuId = this.salesForceInfo.opportunityId;
            }
        }
        this.periodChange();
    };
    OpportunityKobetu.prototype.initDataChange = function () {
        this.form = this.initData;
        this.salesForceAutoComplete();
    };
    OpportunityKobetu.prototype.productChange = function (newProductInfo) {
        this.salesForceInfo.kobetuProductName = newProductInfo['name'];
        this.salesForceInfo.kobetuProductPlanName = newProductInfo['planName'];
        this.salesForceInfo.kobetuPriceBookMonth = newProductInfo['month'];
        this.periodChange();
    };
    OpportunityKobetu.prototype.entryChange = function (newProductItems) {
        this.salesForceInfo.kobetuPriceBookData = newProductItems;
    };
    OpportunityKobetu.prototype.getSalesForcePeriod = function () {
        return object_utils_1.default.getSalesForcePeriod(this.form.applyInfoKinoKunrenPeriod);
    };
    OpportunityKobetu.prototype.initSalesForceDataChange = function () {
        this.salesForceInfo = this.initSalesForceData;
        this.salesForceAutoComplete();
    };
    OpportunityKobetu.prototype.submit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var self_, errorMessage;
            return __generator(this, function (_a) {
                self_ = this;
                event.preventDefault();
                if (value_checker_1.default.isBlank(self_.salesForceInfo.torihikisakiId)) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_torihikisaki_id').toString();
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isBlank(self_.salesForceInfo.kobetuPriceBook2Id)) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_pricebook_id').toString();
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isBlank(String(self_.salesForceInfo.kobetuProductId))) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_product_id').toString();
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isBlank(String(self_.salesForceInfo.kobetuPrice))) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_price').toString();
                    return [2 /*return*/];
                }
                // 無料期間ありの場合。
                if (value_checker_1.default.isPresent(this.useKobetuFreePeriod)) {
                    if (value_checker_1.default.isBlank(self_.salesForceInfo.kobetuFreePriceBook2Id)) {
                        this.showAlertDialog = true;
                        this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_free_pricebook_id').toString();
                        return [2 /*return*/];
                    }
                    if (value_checker_1.default.isBlank(String(self_.salesForceInfo.kobetuFreeProductId))) {
                        this.showAlertDialog = true;
                        this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_free_product_id').toString();
                        return [2 /*return*/];
                    }
                    if (value_checker_1.default.isBlank(String(self_.salesForceInfo.kobetuFreePeriod))) {
                        this.showAlertDialog = true;
                        this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_free_product_period').toString();
                        return [2 /*return*/];
                    }
                }
                if (this.isPriceDifferent() && this.isTokubetuBlank()) {
                    errorMessage = "<div class=\"col\">" +
                        this.$t('view.sales_force.reflect.msg.price_error') +
                        ("<br>\u6A19\u6E96\u4FA1\u683C: <strong>" + this.kobetuPrice + "</strong><br>") +
                        ("\u8CA9\u58F2\u4FA1\u683C: <strong>" + this.salesForceInfo.kobetuPrice + "</strong><br>");
                    this.showAlertDialog = true;
                    this.alertMessage = errorMessage;
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isPresent(self_.salesForceInfo.kobetuBunkatuFlg)
                    && this.isTokubetuBlank()) {
                    this.showAlertDialog = true;
                    this.alertMessage = String(this.$t('view.sales_force.reflect.msg.bunkatu_error'));
                    return [2 /*return*/];
                }
                if (price_book_utils_1.default.isAbnormal(self_.salesForceInfo.kobetuPriceBook2Id, self_.salesForceInfo.useKobetuFreePeriod) &&
                    this.isTokubetuBlank()) {
                    this.showAlertDialog = true;
                    this.alertMessage = String(this.$t('view.sales_force.reflect.msg.tokubetu_error'));
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isPresent(self_.salesForceInfo.opportunityKobetuId) ||
                    value_checker_1.default.isPresent(self_.salesForceInfo.freeOpportunityKobetuId)) {
                    this.confirmMessage = '商談・商談商品オブジェクト（機能訓練）を<strong>更新</strong>します。よろしいですか？';
                }
                else {
                    this.confirmMessage = '商談・商談商品オブジェクト（機能訓練）を<strong>新規に追加</strong>します。よろしいですか？';
                }
                this.showConfirmDialog = true;
                return [2 /*return*/];
            });
        });
    };
    OpportunityKobetu.prototype.dialogClose = function () {
        this.showConfirmDialog = false;
        this.showAlertDialog = false;
    };
    OpportunityKobetu.prototype.reflect = function () {
        var self_ = this;
        self_.dialogClose();
        this.$emit('reflect', this.getAjaxInfo());
    };
    OpportunityKobetu.prototype.getPriceErrorMsg = function () {
        if (this.isPriceDifferent()) {
            return this.$t('view.sales_force.reflect.msg.price_warning');
        }
        return '';
    };
    OpportunityKobetu.prototype.isPriceDifferent = function () {
        return String(this.kobetuPrice) !== String(this.salesForceInfo.kobetuPrice);
    };
    OpportunityKobetu.prototype.isTokubetuBlank = function () {
        return value_checker_1.default.isBlank(this.salesForceInfo.kobetuTokubetuDetail);
    };
    OpportunityKobetu.prototype.getAjaxInfo = function () {
        // カラム追加した項目は、NullCareをしないと、trim()でエラー
        if (!this.salesForceInfo.opportunityKobetuItemId) {
            this.salesForceInfo.opportunityKobetuItemId = '';
        }
        if (!this.salesForceInfo.opportunityKobetuItemId) {
            this.salesForceInfo.opportunityKobetuItemId = '';
        }
        if (!this.salesForceInfo.freeOpportunityKobetuId) {
            this.salesForceInfo.freeOpportunityKobetuId = '';
        }
        if (!this.salesForceInfo.freeOpportunityKobetuItemId) {
            this.salesForceInfo.freeOpportunityKobetuItemId = '';
        }
        var reflectType = [ReflectType_1.SalesForceReflectType.OPPORTUNITY_KOBETU, ReflectType_1.SalesForceReflectType.OPPORTUNITY_ITEM_KOBETU];
        if (value_checker_1.default.isPresent(this.useKobetuFreePeriod)) {
            reflectType.unshift(ReflectType_1.SalesForceReflectType.OPPORTUNITY_ITEM_KOBETU_FREE);
            reflectType.unshift(ReflectType_1.SalesForceReflectType.OPPORTUNITY_KOBETU_FREE);
        }
        return {
            salesForceInfo: {
                torihikisakiId: this.salesForceInfo.torihikisakiId.trim(),
                kobetuPrice: this.salesForceInfo.kobetuPrice,
                kobetuContractState: this.salesForceInfo.kobetuContractState,
                kobetuRequestStartDate: this.salesForceInfo.kobetuRequestStartDate,
                kobetuContractEdate: this.salesForceInfo.kobetuContractEdate,
                kobetuItPeriod: this.salesForceInfo.kobetuItPeriod,
                kobetuBunkatuFlg: this.salesForceInfo.kobetuBunkatuFlg,
                kobetuItFlg: this.salesForceInfo.kobetuItFlg,
                kobetuTokubetuFlg: this.salesForceInfo.kobetuTokubetuFlg,
                kobetuTokubetuDetail: this.salesForceInfo.kobetuTokubetuDetail,
                opportunityKobetuId: this.salesForceInfo.opportunityKobetuId.trim(),
                opportunityKobetuName: this.salesForceInfo.opportunityKobetuName,
                kobetuContractStartDate: this.salesForceInfo.kobetuContractStartDate,
                kobetuPriceBook2Id: this.salesForceInfo.kobetuPriceBook2Id,
                useKobetuFreePeriod: this.salesForceInfo.useKobetuFreePeriod,
                opportunityKobetuItemId: this.salesForceInfo.opportunityKobetuItemId.trim(),
                freeOpportunityKobetuId: this.salesForceInfo.freeOpportunityKobetuId.trim(),
                freeOpportunityKobetuItemId: this.salesForceInfo.freeOpportunityKobetuItemId.trim(),
                freeOpportunityKobetuName: this.salesForceInfo.freeOpportunityKobetuName,
                freeKobetuContractStartDate: this.salesForceInfo.freeKobetuContractStartDate,
                kobetuPriceBookMonth: this.salesForceInfo.kobetuPriceBookMonth,
                kobetuPriceBookData: this.salesForceInfo.kobetuPriceBookData,
                kobetuProductPlanName: this.salesForceInfo.kobetuProductPlanName,
                kobetuCancelFlag: this.salesForceInfo.kobetuCancelFlag,
            },
            reflectType: reflectType,
            fetchTypes: [ReflectType_1.SalesForceReflectType.OPPORTUNITY_KOBETU, ReflectType_1.SalesForceReflectType.TORIHIKISAKI]
        };
    };
    __decorate([
        vue_property_decorator_1.Prop({ default: {} })
    ], OpportunityKobetu.prototype, "initData", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: {} })
    ], OpportunityKobetu.prototype, "initSalesForceData", void 0);
    __decorate([
        vue_property_decorator_1.Prop({
            default: function () {
            }
        })
    ], OpportunityKobetu.prototype, "fetchSalesForceInfo", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: [] })
    ], OpportunityKobetu.prototype, "priceBookData", void 0);
    __decorate([
        vue_property_decorator_1.Watch('useKobetuFreePeriod')
    ], OpportunityKobetu.prototype, "onUseKobetuFreePeriodChange", null);
    __decorate([
        vue_property_decorator_1.Watch('initData')
    ], OpportunityKobetu.prototype, "initDataChange", null);
    __decorate([
        vue_property_decorator_1.Watch('initSalesForceData')
    ], OpportunityKobetu.prototype, "initSalesForceDataChange", null);
    OpportunityKobetu = __decorate([
        vue_property_decorator_1.Component({
            components: {
                FreePeriod: FreePeriod_1.default,
                ProductSelect: ProductSelect_1.default,
                PriceBookSelect: PriceBookSelect_1.default,
                SimpleDialog: SimpleDialog_1.default,
                MoveSalesForceButton: MoveSalesForceButton_1.default,
                DatePickerWrapper: DatePickerWrapper_1.default,
                SalesForceButtonArea: SalesForceButtonArea_1.default,
                DetailDataSingleLabel: DetailDataSingleLabel_1.default
            }
        })
    ], OpportunityKobetu);
    return OpportunityKobetu;
}(vue_property_decorator_1.Vue));
exports.default = OpportunityKobetu;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/sales_force/OpportunityKobetu.vue
// module id = 5MYC
// module chunks = 1